import { DYNAMIC_ROUTE_BUSINESS_SCREEN_MAP, ROUTE_BUSINESS_SCREEN_MAP } from "@/constants";

export function getBusinessRouteScreen(pathname: string) {
  const screen = ROUTE_BUSINESS_SCREEN_MAP[pathname];
  // Check if the pathname matches any of the static routes first
  if (screen) {
    return screen;
  }
  // If not, check against the dynamic business screen map
  const dynamicMatch = Object.entries(DYNAMIC_ROUTE_BUSINESS_SCREEN_MAP).find(([key]) => {
    return pathname.includes(key);
  });

  return dynamicMatch ? dynamicMatch[1] : undefined;
}
